import config from "./config.json";

const { REACT_APP_SERVER_URL } = process.env;

const LOCAL_HOST = "http://localhost:3000";
const CORE_PATH = REACT_APP_SERVER_URL === LOCAL_HOST ? "/core" : "";
const DW_PATH = "/dw";
const EXT_PATH = "/ext";
const CC_PATH = "/cc";
const TAX_PATH = "/tax";
const AP_PATH = "/ap";

export function createOutcomeConfigurationUrl() {
  return new FormatString(config.outcomeConfigurationUrl).addCoreDomainUrl();
}

export function updateOutcomeConfigurationUrl(configId) {
  return new FormatString(config.outcomeConfigurationUrlId)
    .replaceConfigId(configId)
    .addCoreDomainUrl();
}

export function getOutcomeConfigurationUrl() {
  return new FormatString(config.outcomeConfigurationUrl).addCoreDomainUrl();
}

export function getOutcomeConfigurationUnapprovedCountUrl() {
  return new FormatString(
    config.outcomeConfigurationUnapprovedCountUrl
  ).addCoreDomainUrl();
}

export function getContextOutcomesUrl(courseId) {
  return new FormatString(config.contextOutcomesUrl)
    .replaceCourseId(courseId)
    .addCoreDomainUrl();
}

export function getFilesUrl() {
  return new FormatString(config.filesUrl).addCoreDomainUrl();
}

export function getDownloadUrl() {
  return new FormatString(config.downloadUrl).addCoreDomainUrl();
}

export function getExternalDownloadUrl() {
  return new FormatString(config.externalDownloadUrl).addExtDomainUrl();
}

export function getExternalResultsUrl() {
  return new FormatString(config.externalResultsUrl).addExtDomainUrl();
}

export function getPublicResultsUrl() {
  return new FormatString(config.assessmentResultsUrl).addExtDomainUrl();
}

export function getFileContentUrl() {
  return new FormatString(config.fileContentUrl).addCoreDomainUrl();
}

export function getUrlForModifyingOutcomeTaxonomyLevel(outcomeId) {
  return new FormatString(config.outcomesTaxonomyUrl)
    .replaceOutcomeId(outcomeId)
    .addCoreDomainUrl();
}

export function getCoursesUrl() {
  return new FormatString(config.coursesUrl).addCoreDomainUrl();
}

export function getContextOfferingsUrl(contextId) {
  return new FormatString(config.contextOfferingsUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getOfferingsWithPlanDataForContextUrl(contextId) {
  return new FormatString(config.offeringsWithPlanDataForContextUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getContextsUrl() {
  return new FormatString(config.contextsUrl).addCoreDomainUrl();
}

export function getLearningOutcomeUrl(outcomeId) {
  return new FormatString(config.learningOutcomeWithPathParamUrl)
    .replaceOutcomeId(outcomeId)
    .addCoreDomainUrl();
}

export function getLearningOutcomeUnapprovedUrl(outcomeId, contextId) {
  return new FormatString(config.learningOutcomeUnapprovedUrl)
    .replaceOutcomeId(outcomeId)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function updateLearningOutcomeUrl(outcomeId) {
  return new FormatString(config.learningOutcomeWithUpdatePathParamUrl)
    .replaceOutcomeId(outcomeId)
    .addCoreDomainUrl();
}

export function getLearningOutcomesUrl() {
  return new FormatString(config.learningOutcomesUrl).addCoreDomainUrl();
}

export function getLearningOutcomesTaxonomyUrl(taxonomyId) {
  return new FormatString(config.learningOutcomesTaxonomyUrl)
    .replaceTaxonomyId(taxonomyId)
    .addTaxDomainUrl();
}

export function getQualityCheckProgressUrl() {
  return new FormatString(config.qualityCheckProgressUrl).addCoreDomainUrl();
}

export function getTaxonomyLevelUrl(taxonomyId) {
  return new FormatString(config.levelTaxonomyUrl)
    .replaceTaxonomyId(taxonomyId)
    .addTaxDomainUrl();
}

export function getAllAttainmentLevelUrl() {
  return new FormatString(config.attainmentLevelUrl).addCoreDomainUrl();
}

export function getAllTaxonomiesUrl() {
  return new FormatString(
    config.learningOutcomesTaxonomiesUrl
  ).addTaxDomainUrl();
}

export function getTasksUrl() {
  return new FormatString(config.tasksUrl).addCoreDomainUrl();
}

export function getExternalTasksUrl() {
  return new FormatString(config.externalTasksUrl).addExtDomainUrl();
}

export function getCourseCodePatternUrl() {
  return new FormatString(config.courseCodePatternUrl).addCoreDomainUrl();
}

export function getCourseLevelUpdateProgressUrl() {
  return new FormatString(
    config.courseLevelUpdateProgressUrl
  ).addCoreDomainUrl();
}

export function getMappingUrl(mappingId) {
  return new FormatString(config.mappingUrl)
    .replaceMappingId(mappingId)
    .addCoreDomainUrl();
}

export function getMappingsUrl() {
  return new FormatString(config.mappingsUrl).addCoreDomainUrl();
}

export function getSyncedMappingsUrl(contextId) {
  return new FormatString(config.syncedMappingsUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getMasteryLevelsUrl() {
  return new FormatString(config.masteryLevelsUrl).addCoreDomainUrl();
}

export function getMasteryLevelRatingsUrl() {
  return new FormatString(config.masteryLevelRatingsUrl).addCoreDomainUrl();
}

export function updateAssociatedScalesByMapIdUrl(mapId) {
  return new FormatString(config.updateAssociatedScalesByMapIdUrl)
    .replaceMapId(mapId)
    .addCoreDomainUrl();
}

export function getAcademicSubjectsUrl() {
  return new FormatString(config.academicSubjectsUrl).addCoreDomainUrl();
}

export function assignSubjectToAcademicLevelUrl(levelId) {
  return new FormatString(config.assignSubjectsToHierarchyLevelUrl)
    .replaceLevelId(levelId)
    .addCoreDomainUrl();
}

export function getAcademicHierarchyUrl() {
  return new FormatString(config.academicHierarchyUrl).addCoreDomainUrl();
}

export function getAcademicHierarchyLevelsUrl() {
  return new FormatString(config.academicHierarchyLevelsUrl).addCoreDomainUrl();
}

export function getAssessmentPlansUrl() {
  return new FormatString(config.assessmentPlansUrl).addApDomainUrl();
}

export function getExternalAssessmentPlansUrl() {
  return new FormatString(config.externalAssessmentPlansUrl).addExtDomainUrl();
}

export function updateAssessmentEvidenceApprover(planId, assessmentId) {
  return new FormatString(config.assessmentEvidenceApproverUrl)
    .replacePlanId(planId)
    .replaceAssessmentId(assessmentId)
    .addApDomainUrl();
}
export function assessmentEvidenceApprove(planId, assessmentId) {
  return new FormatString(config.assessmentApproveEvidenceUrl)
    .replacePlanId(planId)
    .replaceAssessmentId(assessmentId)
    .addApDomainUrl();
}

export function getQualitativeMeasureUrl() {
  return new FormatString(config.qualitativeMeasureUrl).addApDomainUrl();
}

export function updateQualitativeMeasureUrl(measureId) {
  return new FormatString(config.qualitativeMeasureUrlId)
    .replaceMeasureId(measureId)
    .addApDomainUrl();
}

export function updateExternalQualitativeMeasureUrl(measureId) {
  return new FormatString(config.externalQualitativeMeasureUrlId)
    .replaceMeasureId(measureId)
    .addExtDomainUrl();
}

export function getEmbeddedDashboardUrl() {
  return new FormatString(config.embeddedDashboardUrl).addApDomainUrl();
}

export function updateEmbeddedDashboardUrl(measureId) {
  return new FormatString(config.embeddedDashboardUrlId)
    .replaceLinkId(measureId)
    .addApDomainUrl();
}

export function getAssignmentResultsUrl() {
  return new FormatString(config.assignmentResultsUrl).addCoreDomainUrl();
}

export function getAssignmentByIdUrl(assignmentId) {
  return new FormatString(config.assignmentByIdUrl)
    .replaceAssignmentId(assignmentId)
    .addCoreDomainUrl();
}

export function getAssignmentsBySectionUrl(canvasSectionId) {
  return new FormatString(config.assignmentBySectionUrl)
    .replaceSectionId(canvasSectionId)
    .addCoreDomainUrl();
}

export function getSubmitPurlResultsUrl() {
  return new FormatString(config.submitPurlResultsUrl).addCoreDomainUrl();
}

export function getFacultiesUrl() {
  return new FormatString(config.faculties).addCoreDomainUrl();
}

export function getAssessmentUrl() {
  return new FormatString(config.assessmentUrl).addApDomainUrl();
}

export function getAssignmentsByPlanId(planId) {
  return new FormatString(config.assignmentsByPlanIdUrl)
    .replacePlanId(planId)
    .addCoreDomainUrl();
}

export function getOfferingsUrl(facultyId) {
  return new FormatString(config.offeringsUrlId)
    .replaceFacultyId(facultyId)
    .addCoreDomainUrl();
}

export function getSectionsUrl() {
  return new FormatString(config.sectionsUrl).addCoreDomainUrl();
}

export function getSectionsContextsUrl() {
  return new FormatString(config.sectionsContextsUrl).addCoreDomainUrl();
}

export function getOfferingsBaseUrl() {
  return new FormatString(config.offeringsUrl).addCoreDomainUrl();
}

export function updateAssessmentUrl(assessmentId) {
  return new FormatString(config.assessmentUpdateUrlId)
    .replaceAssessmentId(assessmentId)
    .addApDomainUrl();
}

export function updateAssessmentPlanReviewersUrl(planId) {
  return new FormatString(config.assessmentPlanUpdateReviewersUrl)
    .replacePlanId(planId)
    .addApDomainUrl();
}

export function updateAssessmentPlanSequencesUrl(planId) {
  return new FormatString(config.assessmentPlanUpdateSequencesUrl)
    .replacePlanId(planId)
    .addApDomainUrl();
}

export function assessmentPlanSectionUrl(sectionId) {
  return new FormatString(config.assessmentPlanSectionUrl)
    .replaceSectionId(sectionId)
    .addApDomainUrl();
}

export function sectionUrl(planId) {
  return new FormatString(config.sectionUrl)
    .replacePlanId(planId)
    .addApDomainUrl();
}

export function getAssessmentStudentsEvidenceUrl(assessmentId) {
  return new FormatString(config.assessmentStudentsEvidenceUrl)
    .replaceAssessmentId(assessmentId)
    .addCoreDomainUrl();
}

export function getExternalAssessmentsStudentsEvidenceUrl(assessmentId) {
  return new FormatString(config.externalAssessmentStudentsEvidenceUrl)
    .replaceAssessmentId(assessmentId)
    .addExtDomainUrl();
}

export function getAssignmentTypesUrl() {
  return new FormatString(config.assignmentTypesUrl).addCoreDomainUrl();
}

export function getExternalAssignmentTypesUrl() {
  return new FormatString(config.externalAssignmentTypesUrl).addExtDomainUrl();
}

export function getProgramTypesUrl() {
  return new FormatString(config.programTypesUrl).addCoreDomainUrl();
}

export function getProgramLevelsUrl() {
  return new FormatString(config.programLevelsUrl).addCoreDomainUrl();
}

export function getCourseCodeErrorsUrl() {
  return new FormatString(config.courseCodeErrorsUrl).addCoreDomainUrl();
}

export function getCourseGroupsUrl() {
  return new FormatString(config.courseGroupsUrl).addCoreDomainUrl();
}

export function getGroupTypesUrl() {
  return new FormatString(config.groupTypesUrl).addCoreDomainUrl();
}

export function getAssessmentPlansPushToCanvasUrl(planId) {
  return new FormatString(config.assessmentPlansPushToCanvasUrl)
    .replacePlanId(planId)
    .addApDomainUrl();
}

export function getAcademicYearsUrl() {
  return new FormatString(config.academicYearsUrl).addCoreDomainUrl();
}

export function getAcademicYearsByIdUrl(yearId) {
  return new FormatString(config.academicYearsByIdUrl)
    .replaceYearId(yearId)
    .addCoreDomainUrl();
}

export function getTermsUrl() {
  return new FormatString(config.termsUrl).addCoreDomainUrl();
}

export function getInsightsTermsUrl() {
  return new FormatString(config.insightsTermsUrl).addCoreDomainUrl();
}

export function getInsightsTermsByIdUrl(termId) {
  return new FormatString(config.insightsTermsUrlId)
    .replaceTermId(termId)
    .addCoreDomainUrl();
}

export function getActionsUrl() {
  return new FormatString(config.actionsUrl).addCoreDomainUrl();
}

export function getExternalActionsUrl() {
  return new FormatString(config.actionsExternalUrl).addExtDomainUrl();
}

export function getActionsForContextUrl() {
  return new FormatString(config.actionsForContextUrl).addCoreDomainUrl();
}

export function getExternalActionsForContextUrl() {
  return new FormatString(
    config.actionsForContextExternalUrl
  ).addExtDomainUrl();
}

export function getActionTypesUrl() {
  return new FormatString(config.actionTypesUrl).addCoreDomainUrl();
}

export function getExternalActionTypesUrl() {
  return new FormatString(config.actionTypesExternalUrl).addExtDomainUrl();
}

export function getEnhancedOutcomeStatementUrl() {
  return new FormatString(
    config.learningOutcomesEnhanceStatementUrl
  ).addCoreDomainUrl();
}

export function getSignOutUrl() {
  return new FormatString(config.signOutUrl).addCoreDomainUrl();
}

export function getReflectionsUrl() {
  return new FormatString(config.reflectionsUrl).addCoreDomainUrl();
}

export function getExternalReflectionsUrl() {
  return new FormatString(config.reflectionsExternalUrl).addExtDomainUrl();
}

export function getFindingsUrl() {
  return new FormatString(config.findingsUrl).addCoreDomainUrl();
}

export function getRecsUrl() {
  return new FormatString(config.recommendationsUrl).addCoreDomainUrl();
}

export function getQualityMetricsUrl() {
  return new FormatString(config.qualityMetricsUrl).addCoreDomainUrl();
}

export function getUsersUrl() {
  return new FormatString(config.usersUrl).addCoreDomainUrl();
}

export function getExternalUsersUrl() {
  return new FormatString(config.usersExternalUrl).addExtDomainUrl();
}

export function getRosterUrl(contextId) {
  return new FormatString(config.rosterUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getExternalRosterUrl(contextId) {
  return new FormatString(config.rosterExternalUrl)
    .replaceContextId(contextId)
    .addExtDomainUrl();
}

export function getExternalSubjectsByIdsUrl() {
  return new FormatString(config.externalSubjectsByIdsUrl).addExtDomainUrl();
}

export function getCategoryUrl() {
  return new FormatString(config.outcomeCategoriesUrl).addCoreDomainUrl();
}

export function getCategoryByTypeUrl(loType) {
  return new FormatString(config.outcomeCategoryByTypeUrl)
    .replaceLoType(loType)
    .addCoreDomainUrl();
}

export function getCategoryByIdUrl(categoryId) {
  return new FormatString(config.outcomeCategoryUrlWithParam)
    .replaceCategoryId(categoryId)
    .addCoreDomainUrl();
}

export function getOutcomesByCategoryUrl(categoryId) {
  return new FormatString(config.outcomesByCategoryUrl)
    .replaceCategoryId(categoryId)
    .addCoreDomainUrl();
}

export function getShareUrl() {
  return new FormatString(config.shareUrl).addCoreDomainUrl();
}

export function getExternalShareUrl() {
  return new FormatString(config.externalShareUrl).addExtDomainUrl();
}

export function getShareWithIdUrl(shareCodeId) {
  return new FormatString(config.shareCodeIdUrl)
    .replaceShareCodeId(shareCodeId)
    .addCoreDomainUrl();
}

export function getVerifyUrl() {
  return new FormatString(config.verifyUrl).addExtDomainUrl();
}

export function getShareCodeUrl(shareCodeId) {
  return new FormatString(config.shareCodeUrl)
    .replaceShareCodeId(shareCodeId)
    .addExtDomainUrl();
}

export function getShareCodeByPlanUrl(planId) {
  return new FormatString(config.shareCodeByPlanUrl)
    .replacePlanId(planId)
    .addCoreDomainUrl();
}

export function getPurlDataUrl(purlId) {
  return new FormatString(config.purlDataUrl)
    .replacePurlId(purlId)
    .addCoreDomainUrl();
}

export function getCategoryByContextIdUrl(contextId) {
  return new FormatString(config.getOutcomeCategoriesByContextUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getUncategorizedOutcomesByContextUrl(contextId) {
  return new FormatString(config.getUncategorizedOutcomesByContextUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getAcSubjectsUrl() {
  return new FormatString(config.usersAcSubjectsUrl).addCoreDomainUrl();
}

export function getResultsUrl() {
  return new FormatString(config.assessmentResultsUrl).addCoreDomainUrl();
}

export function getResultsBySectionUrl() {
  return new FormatString(
    config.assessmentResultsBySectionUrl
  ).addCoreDomainUrl();
}

export function getObjectivesUrl() {
  return new FormatString(config.objectivesUrl).addCoreDomainUrl();
}
export function updateObjectiveUrl(objectiveId) {
  return new FormatString(config.objectivesUrlId)
    .replaceObjectiveId(objectiveId)
    .addCoreDomainUrl();
}

export function getGoalsUrl() {
  return new FormatString(config.goalsUrl).addCoreDomainUrl();
}

export function updateGoalUrl(goalId) {
  return new FormatString(config.goalsUrlId)
    .replaceGoalId(goalId)
    .addCoreDomainUrl();
}

export function getCyclesUrl() {
  return new FormatString(config.cycleUrl).addCoreDomainUrl();
}

export function getExternalCyclesUrl() {
  return new FormatString(config.externalCycleUrl).addExtDomainUrl();
}

export function updateCyclesUrl(cycleId) {
  return new FormatString(config.cycleUrlId)
    .replaceCycleId(cycleId)
    .addCoreDomainUrl();
}

export function getCycleTypesUrl() {
  return new FormatString(config.cycleTypesUrl).addCoreDomainUrl();
}
export function getDefaultRatingToMasteryLevelMapUrl(mapId) {
  return new FormatString(config.defaultRatingToMasteryLevelMapUrl)
    .replaceMapId(mapId)
    .addCoreDomainUrl();
}

export function updateCycleTypeUrl(cycleTypeId) {
  return new FormatString(config.cycleTypesUrlId)
    .replaceCycleTypeId(cycleTypeId)
    .addCoreDomainUrl();
}

export function getRatingScaleUrl(outcomeId) {
  return new FormatString(config.ratingScaleUrl)
    .replaceOutcomeId(outcomeId)
    .addCoreDomainUrl();
}

export function getAssignmentRubricUrl() {
  return new FormatString(config.assignmentRubricUrl).addCoreDomainUrl();
}

export function getUnmappedRatingScaleUrl() {
  return new FormatString(config.unmappedRatingScaleUrl).addCoreDomainUrl();
}

export function updateOutcomeDefaultScaleUrl(outcomeId) {
  return new FormatString(config.learningOutcomeDefaultScaleUrl)
    .replaceOutcomeId(outcomeId)
    .addCoreDomainUrl();
}

export function getEvidenceUrl() {
  return new FormatString(config.evidenceUrl).addCoreDomainUrl();
}

export function getDashboardResultsUrl() {
  return new FormatString(config.dashboardResultsUrl).addDwDomainUrl();
}

export function getExternalAssessmentResultsUrl() {
  return new FormatString(
    config.externalAssessmentResultsUrl
  ).addExtDomainUrl();
}

export function getExternalDashboardResultsUrl() {
  return new FormatString(config.externalDashboardResultsUrl).addExtDomainUrl();
}

export function getExternalOutcomesByIdsUrl() {
  return new FormatString(config.externalBulkOutcomesUrl).addExtDomainUrl();
}

export function getAssesmentFindingsUrl() {
  return new FormatString(config.assessmentFindingsUrl).addCoreDomainUrl();
}

export function getAssessmentRecommendationsUrl() {
  return new FormatString(
    config.assessmentRecommendationsUrl
  ).addCoreDomainUrl();
}

export function getErrorPageForErrorCode(errorCode) {
  return "error?type=" + (config["errorPage" + errorCode] || "general");
}

export function getOutcomeForProgramUrl() {
  return new FormatString(config.learningOutcomesForProgram).addCoreDomainUrl();
}

export function getOutcomeForProgramWithParamsUrl(programId) {
  return new FormatString(config.learningOutcomeForProgramWithParam)
    .replaceProgramId(programId)
    .addCoreDomainUrl();
}
export function getProgramsUrl() {
  return new FormatString(config.programsUrl).addCoreDomainUrl();
}

export function getProgramsUrlWithParam(id) {
  return new FormatString(config.programsBySubUrl)
    .replaceAcSubId(id)
    .addCoreDomainUrl();
}

export function getCourseGroupsByProgramUrl(programId) {
  return new FormatString(config.courseGroupsByProgramUrl)
    .replaceProgramId(programId)
    .addCoreDomainUrl();
}
export function getProgramByIdUrl(programId) {
  return new FormatString(config.programByIdUrl)
    .replaceProgramId(programId)
    .addCoreDomainUrl();
}

export function getOutcomeCategoriesUrl() {
  return new FormatString(config.outcomeCategoriesUrl).addCoreDomainUrl();
}

export function getExternalShareCodeUrl(shareCodeId) {
  return new FormatString(config.externalGetShareCodeUrl)
    .replaceShareCodeId(shareCodeId)
    .addExtDomainUrl();
}

export function getExternalPurlDataUrl(purlId) {
  return new FormatString(config.externalPurlUrl)
    .replacePurlId(purlId)
    .addExtDomainUrl();
}

export function getExternalEmailUrl() {
  return new FormatString(config.externalVerifyEmailUrl).addExtDomainUrl();
}

export function getExternalPurlUrl() {
  return new FormatString(config.externalSubmitPurlUrl).addExtDomainUrl();
}

export function getExternalScoresUrl(assignment_id) {
  return new FormatString(config.externalScoresByAssessorUrl)
    .replaceAssignmentId(assignment_id)
    .addExtDomainUrl();
}

export function getExternalAvgScores(assignmentId) {
  return new FormatString(config.externalAvgScoresUrl)
    .replaceAssignmentId(assignmentId)
    .addExtDomainUrl();
}

export function getExternalFindingsUrl() {
  return new FormatString(config.externalGetFindingsUrl).addExtDomainUrl();
}

export function getExternalRecommendationsUrl() {
  return new FormatString(config.externalRecUrl).addExtDomainUrl();
}

export function getExternalFileUrl() {
  return new FormatString(config.externalFileUrl).addExtDomainUrl();
}

export function getExternalFileContentUrl() {
  return new FormatString(config.externalFileContentUrl).addExtDomainUrl();
}

export function getExternalMasteryMapUrl(mapId) {
  return new FormatString(config.externalMasteryMapUrl)
    .replaceMapId(mapId)
    .addExtDomainUrl();
}

export function getExternalMasteryLevelUrl() {
  return new FormatString(config.externalMasteryLevelUrl).addExtDomainUrl();
}

export function getExternalAssessmentURl() {
  return new FormatString(config.externalAssessmentUrl).addExtDomainUrl();
}

export function getExternalPurlUrlById(purlId) {
  return new FormatString(config.externalPurlUrl)
    .replacePurlId(purlId)
    .addExtDomainUrl();
}

export function getExternalAssignmentUrl(assignmentId) {
  return new FormatString(config.externalAssignmentUrl)
    .replaceAssignmentId(assignmentId)
    .addExtDomainUrl();
}

export function getIssuersUrl() {
  return new FormatString(config.issuersUrl).addCcDomainUrl();
}

export function getBadgeClassesByIssuerUrl(entityId) {
  return new FormatString(config.badgeClassesByIssuerUrl)
    .replaceEntityId(entityId)
    .addCcDomainUrl();
}

export function getBadgeMappingsUrl() {
  return new FormatString(config.badgeMappingsUrl).addCcDomainUrl();
}

export function getBadgeMappingsByIdUrl(mappingId) {
  return new FormatString(config.badgeMappingByMapIdUrl)
    .replaceBadgeMappingId(mappingId)
    .addCcDomainUrl();
}

export function getExternalTerms() {
  return new FormatString(config.externalTermsUrl).addExtDomainUrl();
}

export function getExternalInsightsTerms() {
  return new FormatString(config.externalInsightsTermsUrl).addExtDomainUrl();
}

export function getFeatureFlagsUrl() {
  return new FormatString(config.featureFlagsUrl).addCoreDomainUrl();
}
export function getCurriculumMapsForContextUrl(contextId) {
  return new FormatString(config.curriculumMapsForContextUrl)
    .replaceContextId(contextId)
    .addCoreDomainUrl();
}

export function getUpsertCurriculumMapUrl() {
  return new FormatString(config.upsertCurriculumMapUrl).addCoreDomainUrl();
}

export function updateCurriculumMapTermUrl(mapId) {
  return new FormatString(config.updateCurriculumMapTermUrl)
    .replaceMapId(mapId)
    .addCoreDomainUrl();
}

export function getTemplatesUrl() {
  return new FormatString(config.templatesUrl).addApDomainUrl();
}

export function getTemplateByIdUrl(templateId) {
  return new FormatString(config.templateByIdUrl)
    .replaceTemplateId(templateId)
    .addApDomainUrl();
}

export function getDownloadErrorFileUrl(filePath, fileName, fileKey) {
  return new FormatString(config.downloadErrorFileUrl)
    .replaceFilePath(filePath)
    .replaceFileName(fileName)
    .replaceFileKey(fileKey)
    .addCoreDomainUrl();
}

export class FormatString extends String {
  constructor(x = "") {
    super(x);
  }

  fmt = (hash) => {
    let string = this.toString(),
      key;
    for (key in hash) {
      string = string.replace(
        new RegExp("\\$\\{" + key + "\\}", "gm"),
        hash[key]
      );
    }
    return new FormatString(string);
  };

  replaceYearId = (yearId) => {
    return this.fmt({ yearId: yearId });
  };

  replaceTermId = (termId) => {
    return this.fmt({ termId: termId });
  };

  replaceOutcomeId = (outcomeId) => {
    return this.fmt({ outcomeId: outcomeId });
  };

  replaceAssignmentRubricId = (assignmentRubricId) => {
    return this.fmt({ assignmentRubricId: assignmentRubricId });
  };

  replaceCourseId = (courseId) => {
    return this.fmt({ courseId: courseId });
  };

  replaceTaxonomyId = (taxonomyId) => {
    return this.fmt({ taxonomyId: taxonomyId });
  };

  replaceMappingId = (mappingId) => {
    return this.fmt({ mappingId: mappingId });
  };

  replacePlanId = (planId) => {
    return this.fmt({ planId: planId });
  };

  replaceFacultyId = (facultyId) => {
    return this.fmt({ facultyId: facultyId });
  };

  replaceCanvasId = (canvasId) => {
    return this.fmt({ canvasId: canvasId });
  };

  replaceAssessmentId = (assessmentId) => {
    return this.fmt({ assessmentId: assessmentId });
  };

  replaceMeasureId = (measureId) => {
    return this.fmt({ measureId: measureId });
  };

  replaceAssignmentId = (assignmentId) => {
    return this.fmt({ assignmentId: assignmentId });
  };

  replaceGoalId = (goalId) => {
    return this.fmt({ goalId: goalId });
  };

  replaceObjectiveId = (objectiveId) => {
    return this.fmt({ objectiveId: objectiveId });
  };

  replaceCycleId = (cycleId) => {
    return this.fmt({ cycleId: cycleId });
  };

  replaceContextId = (contextId) => {
    return this.fmt({ contextId: contextId });
  };

  replaceCycleTypeId = (cycleTypeId) => {
    return this.fmt({ cycleTypeId: cycleTypeId });
  };

  replaceLevelId = (levelId) => {
    return this.fmt({ levelId: levelId });
  };

  replaceCategoryId = (categoryId) => {
    return this.fmt({ outcomeCategoryId: categoryId });
  };

  replaceShareCodeId = (shareCodeId) => {
    return this.fmt({ shareCodeId: shareCodeId });
  };

  replacePurlId = (purlId) => {
    return this.fmt({ purlId: purlId });
  };

  replaceLoType = (loType) => {
    return this.fmt({ loType: loType });
  };

  replaceConfigId = (configId) => {
    return this.fmt({ configId: configId });
  };

  replaceAcSubId = (acSub) => {
    return this.fmt({ acSub: acSub });
  };

  replaceSubIds = (subIds) => {
    return this.fmt({ academicSubjectIds: subIds });
  };

  replaceProgramId = (programId) => {
    return this.fmt({ programId: programId });
  };

  replaceMapId = (mapId) => {
    return this.fmt({ mapId: mapId });
  };

  replaceLinkId = (linkId) => {
    return this.fmt({ linkId: linkId });
  };

  replaceOfferingId = (offeringId) => {
    return this.fmt({ offeringId: offeringId });
  };

  replaceSectionId = (sectionId) => {
    return this.fmt({ sectionId: sectionId });
  };

  replaceEnrichedVal = (enriched) => {
    return this.fmt({ enriched: enriched });
  };

  replaceEntityId = (entityId) => {
    return this.fmt({ entityId: entityId });
  };

  replaceBadgeMappingId = (mappingId) => {
    return this.fmt({ mapping_id: mappingId });
  };

  replaceTemplateId = (templateId) => {
    return this.fmt({ templateId: templateId });
  };

  addCoreDomainUrl = () => {
    return REACT_APP_SERVER_URL + CORE_PATH + this.toString();
  };

  addDwDomainUrl = () => {
    return REACT_APP_SERVER_URL + DW_PATH + this.toString();
  };

  addExtDomainUrl = () => {
    return REACT_APP_SERVER_URL + EXT_PATH + this.toString();
  };

  addTaxDomainUrl = () => {
    return REACT_APP_SERVER_URL + TAX_PATH + this.toString();
  };
  addCcDomainUrl = () => {
    return REACT_APP_SERVER_URL + CC_PATH + this.toString();
  };
  addApDomainUrl = () => {
    return REACT_APP_SERVER_URL + AP_PATH + this.toString();
  };

  replaceFilePath = (filePath) => {
    return this.fmt({ filePath: filePath });
  };

  replaceFileName = (fileName) => {
    return this.fmt({ fileName: fileName });
  };

  replaceFileKey = (fileKey) => {
    return this.fmt({ fileKey: fileKey });
  };
}
